import { TAB_PREFIX } from '@/components/confirmationModals/useFormConfirmationModal.ts';

type UriCompositionResult = {
  protocol?: string;
  server?: string;
  path?: string;
  search?: string;
  searchParams?: URLSearchParams;
  prefix?: string;
  key?: string;
};

export function getUrlComposition(
  url: string,
  options?: { prefix?: string },
): UriCompositionResult {
  const defaultOptions = {
    prefix: TAB_PREFIX,
  };
  const mergedOptions = { ...defaultOptions, ...options };

  const hashQueryExpression = new RegExp(
    `(?<protocol>(http://|https://))?(?<server>(?<=/)([\\w.-]*))?(?<path>[\\w/.-]*)?(?<query>\\?.*)?(?<prefix>#${mergedOptions.prefix})(?<key>[\\w-]*)`,
  );
  const hashQueryMatches = RegExp(hashQueryExpression).exec(url);

  if (!hashQueryMatches?.groups) {
    return {
      prefix: mergedOptions.prefix,
    };
  } else {
    const { protocol, server, path, prefix, key, query: search } = hashQueryMatches.groups;

    const searchParams = new URLSearchParams(search);

    return {
      server,
      protocol,
      path,
      prefix,
      key,
      search: searchParams.toString(),
      searchParams,
    };
  }
}
